// Utility to display category/subcategory name from its key
// Uses i18n translations first, then falls back to API cache, then formats the slug

let categoryCache = {};

export const setCategoryCache = (categories) => {
  categoryCache = {};
  for (const cat of categories) {
    categoryCache[cat.value] = cat.name;
  }
};

// t is the react-i18next translation function — pass it from the component
export const getCategoryName = (key, t) => {
  if (!key) return '';
  // 1. Check i18n translation (if t function provided)
  if (t) {
    const translated = t(`categories.${key}`, { defaultValue: '' });
    if (translated) return translated;
  }
  // 2. Fallback to API cache
  if (categoryCache[key]) return categoryCache[key];
  // 3. Fallback: format slug nicely
  return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};

export const getSubcategoryName = (key, t) => {
  if (!key) return '';
  // 1. Check i18n translation (if t function provided)
  if (t) {
    const translated = t(`subcategories.${key}`, { defaultValue: '' });
    if (translated) return translated;
  }
  // 2. Fallback: format slug nicely
  return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
